import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import "../calender/TicketCalender.css";
import { IoIosArrowDown, IoIosArrowDropleftCircle, IoIosArrowDroprightCircle, IoIosArrowUp } from "react-icons/io";
import { toast } from 'react-toastify';

const generateWeeks = (selectedDate) => {
    return Array.from({ length: 6 }).map((_, index) => {
        const start = moment(selectedDate)
            .startOf('month')
            .add(index, 'week')
            .startOf('week');
        return Array.from({ length: 7 }).map((_, dayIndex) => {
            const date = moment(start).add(dayIndex, 'day');
            return {
                weekday: date.format('ddd'),
                date: date.toDate(),
            };
        });
    });
};

const TicketCalender = ({ handleFilteredTicketDate, pageName, holidate, initialDate }) => {

    // optional starting date (e.g. restored after coming back to the page)
    const startDate = initialDate instanceof Date && !isNaN(initialDate.getTime()) ? initialDate : null;

    const [weekMonthONOFF, setweekMonthONOFF] = useState(false);
    const [value, setValue] = useState(startDate || new Date());
    const [disable, setDisable] = useState(false);

    const [selectedDate, setSelectedDate] = useState(startDate ? moment(startDate).format("DD MMMM YYYY") : '');
    const [weeks, setWeeks] = useState(generateWeeks(value));
    const scrollViewRef = useRef(null);
    const [showVerticalCalendar, setShowVerticalCalendar] = useState(false);
    const [currentYear, setCurrentYear] = useState(moment(startDate || undefined).year());
    const [currentMonth, setCurrentMonth] = useState(moment(startDate || undefined).month());
    const [weekDisabled, setWeekDisabled] = useState(false)
    const [weekOrMonth, setWeekOrMonth] = useState('Week')
    const [selectStatus, setSelectStatus] = useState(true)
    const [currentDate, setCurrentDate] = useState((startDate || new Date()).toDateString());
    useEffect(() => {
        setWeeks(generateWeeks(value));
    }, [value]);

    useEffect(() => {
        if (value && typeof handleFilteredTicketDate === 'function') {
            const momentDate = moment(value);
            const formattedDate = momentDate.format("DD-MM-YYYY");

            const today = moment().format("DD-MM-YYYY");
            const newDates = selectStatus == true ? moment(value).format("DD-MM-YYYY") : "";

            const day = momentDate.date();
            const month = momentDate.month() + 1;
            const year = momentDate.year();
            const d = new Date();
            const current_month = d.getMonth() + 1;
            const current_year = d.getFullYear();


            if (weekOrMonth == "Week") {
                const weekAllowed = moment(value).startOf('week').isAfter(moment().startOf('week'));
                setWeekDisabled(weekAllowed);

            } else if (weekOrMonth == "Month") {
                const weekresult = current_year < year || (current_year == year && current_month < month);
                setWeekDisabled(weekresult)
            }
            let localpreviesdate = localStorage.getItem('previesdate') ? JSON.parse(localStorage.getItem('previesdate')) : '';


            handleFilteredTicketDate(localpreviesdate ? localpreviesdate : selectedDate ? moment(selectedDate).format("D MMMM YYYY") : moment().format("D MMMM YYYY"));
        }
    }, [value, disable, weekDisabled]);



    useEffect(() => {
        const hasDisabledDates = weeks.some((week) =>
            week.some((day) => isDisabled(day.date))
        );
        setDisable(hasDisabledDates);
    }, [weeks, value]);


    const isDisabled = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
        return today > date;
    };


    const toggleOption = (option) => {
        if (option == 'Month') {
            setweekMonthONOFF(true);
            setWeekOrMonth('Month')
        } else {
            setweekMonthONOFF(false);
            setWeekOrMonth('Week')
        }
        if (scrollViewRef.current) {
            scrollViewRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
        setShowVerticalCalendar(prev => !prev);
    };

    const handleCalenderBoxPress = async (clickedDate, disabled) => {
        setSelectStatus(true)
        const today = new Date()

        let localpreviesdate = localStorage.getItem('previesdate') ? JSON.parse(localStorage.getItem('previesdate')) : '';

        setCurrentDate(clickedDate.toDateString())
        const newDate = clickedDate ? moment(clickedDate) : moment(today);
        setValue(newDate.toDate());


        const formattedDate = newDate.format("DD-MM-YYYY");
        const formattedDateString = newDate.format("DD MMMM YYYY");
        const selectedDateFormat = { day: newDate.date(), month: newDate.month() + 1, year: newDate.year() };
        // setSelectedDate(formattedDate);
        setweekMonthONOFF(false);
        setWeekOrMonth("Week")
        // localStorage.setItem('previesdate', JSON.stringify(formattedDate));


        handleFilteredTicketDate(formattedDate);
        setSelectedDate(formattedDateString)

        if (scrollViewRef.current) {
            scrollViewRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }

        setCurrentYear(newDate.year());
        setCurrentMonth(newDate.month())
    };


    const generateWeeksForMonth = (selectedDate) => {
        const startOfMonth = moment(selectedDate).startOf('month');
        const endOfMonth = moment(selectedDate).endOf('month');
        const weeksArray = [];
        let currentWeek = [];
        for (
            let currentDay = startOfMonth.clone();
            currentDay.isBefore(endOfMonth);
            currentDay.add(1, 'day')
        ) {
            currentWeek.push({
                weekday: currentDay.format('ddd'),
                date: currentDay.toDate(),
            });
            if (currentDay.weekday() === 6) {
                weeksArray.push([...currentWeek]);
                currentWeek = [];
            }
        }
        if (currentWeek.length > 0) {
            weeksArray.push([...currentWeek]);
        }

        return weeksArray;
    };
    const updateMonthYear = (increment) => {

        const newDate = moment(value).add(increment, weekOrMonth).toDate()
        setValue(newDate);
        const previousMonth = moment(value).month();
        const previousYear = moment(value).year();
        const newMonth = moment(newDate).month();
        const newYear = moment(newDate).year();
        if (weekOrMonth != "Week" || newMonth !== previousMonth || newYear !== previousYear) {
            setCurrentYear(newYear);
            setCurrentMonth(newMonth);
        }
        setWeeks(generateWeeksForMonth(newDate));


    };

    const showToast = () => {
        toast.error(`The previous ${weekOrMonth == "Week" ? "week" : "month"} is not  selectable`, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
        });
    }


    const formatYMD = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };
    const normalizedHolidays = holidate?.additional_holidays ?? [];

    const normalizedCurrentDate = currentDate
        ? formatYMD(new Date(currentDate))
        : null;

    const findActiveIndex = (dates, normalizedHolidays, normalizedCurrentDate) => {
        if (!normalizedCurrentDate) return -1;

        let index = dates.findIndex(
            d => formatYMD(d.date) === normalizedCurrentDate
        );

        if (index === -1) return -1;

        if (!normalizedHolidays?.includes(normalizedCurrentDate)) {
            return index;
        }
        for (let i = index - 1; i >= 0; i--) {
            if (!normalizedHolidays?.includes(formatYMD(dates[i].date))) {
                return i;
            }
        }

        for (let i = index + 1; i < dates.length; i++) {
            if (!normalizedHolidays?.includes(formatYMD(dates[i].date))) {
                return i;
            }
        }

        return -1;
    };

    const weekdayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
    };

    const regularHolidayDays = holidate?.regular_holidays?.map(day => weekdayMap[day]) || [];

    const isHoliday = (dateObj) => {
        const ymd = formatYMD(dateObj);
        const day = dateObj.getDay();

        return (
            normalizedHolidays.includes(ymd) ||
            regularHolidayDays.includes(day)
        );
    };


    return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '', cursor: 'default' }}>

            <div style={{ backgroundColor: '#fff', width: '100%', flexDirection: 'column', paddingBottom: 10, borderBottomRightRadius: 8, borderBottomLeftRadius: 8 }}>
                <div className="calendar-header">

                    {/* LEFT: MONTH NAV */}
                    <div className="calendar-month-nav">
                        <button
                            className="calendar-nav-btn"
                            onClick={() => { weekDisabled == false ? showToast() : updateMonthYear(-1) }}
                        >
                            <IoIosArrowDropleftCircle
                                size={25}
                                className={weekDisabled == false ? "disabled-icon" : "primary-text"}
                            />
                        </button>

                        <span className="calendar-month-text">
                            {moment({ year: currentYear, month: currentMonth, day: 1 }).format('MMM YYYY')}
                        </span>

                        <button
                            className="calendar-nav-btn"
                            onClick={() => updateMonthYear(1)}
                        >
                            <IoIosArrowDroprightCircle size={25} className="primary-text" />
                        </button>
                    </div>

                    {/* CENTER: SELECTED DATE */}
                    <div className="calendar-selected-date">
                        {selectedDate
                            ? moment(selectedDate).format("D MMMM YYYY")
                            : moment().format("D MMMM YYYY")}
                    </div>

                    {/* RIGHT: TOGGLE */}
                    <div className="calendar-toggle">
                        <button
                            className={`calendar-toggle-btn ${!weekMonthONOFF ? 'active' : ''}`}
                            onClick={() => toggleOption('Week')}
                        >
                            Week
                        </button>

                        <button
                            className={`calendar-toggle-btn ${weekMonthONOFF ? 'active' : ''}`}
                            onClick={() => toggleOption('Month')}
                        >
                            Month
                        </button>
                    </div>

                </div>

                {weekMonthONOFF ? (
                    <div style={{ backgroundColor: '#fff', paddingLeft: 5, paddingRight: 5, }}>
                        {showVerticalCalendar ? (
                            <div ref={scrollViewRef} style={{ overflowX: 'hidden', scrollBehavior: 'smooth' }}>
                                {weeks.map((dates, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginHorizontal: -4, paddingVertical: 10, paddingHorizontal: 5 }}>
                                        {dates.map((item, dateIndex) => {
                                            const isActive = selectStatus ? (currentDate === item.date.toDateString()) : false
                                            const disabled = isDisabled(item.date);
                                            return (
                                                <div key={dateIndex} onClick={() => { if (!disabled) handleCalenderBoxPress(item.date, item.weekday); }}>

                                                    <div style={{ backgroundColor: disabled ? '#cccc' : '' }} className={`calender-cardBox ${isActive ? 'primary-bg' : '#ECECEC'} `}>
                                                        <span style={{ color: disabled ? '#000' : isActive ? '#fff' : '#000', fontSize: 12 }}>
                                                            {item.weekday}
                                                        </span>
                                                        <span style={{ color: disabled ? '#000' : isActive ? '#fff' : '#000', fontSize: 10 }}>
                                                            {item.date.getDate()}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div ref={scrollViewRef} style={{ overflowX: 'hidden', scrollBehavior: 'smooth' }}>
                                {weeks.map((dates, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginHorizontal: -4, paddingVertical: 10, paddingHorizontal: 5 }}>
                                        {dates.map((item, dateIndex) => {
                                            const isActive = selectStatus ? (currentDate === item.date.toDateString()) : false
                                            const disabled = isDisabled(item.date);

                                            return (
                                                <div key={dateIndex} onClick={() => {
                                                    if (!disabled) handleCalenderBoxPress(item.date, item.weekday);
                                                }}>

                                                    <div style={{ backgroundColor: disabled ? '#cccc' : '' }} className={` calender-cardBox test ${isActive ? 'primary-bg' : '#ECECEC'}`}  >
                                                        <span style={{ color: disabled ? '#000' : isActive ? '#fff' : '#000', fontSize: 12 }}>
                                                            {item.weekday}
                                                        </span>
                                                        <span style={{ color: disabled ? '#000' : isActive ? '#fff' : '#000', fontSize: 10 }}>
                                                            {item.date.getDate()}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        )}
                        <div style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginTop: 10 }}
                            onClick={() => (setweekMonthONOFF(false), setWeekOrMonth("Week"))}>
                            <IoIosArrowUp onClick={() => setweekMonthONOFF(false)} size={20} color='#ccc' />
                        </div>
                    </div>
                ) : (
                    <div style={{ backgroundColor: '#fff', paddingLeft: 5, paddingRight: 5 }}>
                        {weeks
                            .filter((week) =>
                                week.some(
                                    (day) =>
                                        day.date.getFullYear() === value.getFullYear() &&
                                        day.date.getMonth() === value.getMonth() &&
                                        day.date.getDate() === value.getDate()
                                )
                            )
                            .map((dates, weekIndex) => {
                                let skipTill = -1;

                                const activeIndex = selectStatus ? findActiveIndex(dates, normalizedHolidays, normalizedCurrentDate) : -1;


                                return (
                                    <div className="calender-date-list" key={weekIndex}>
                                        {dates?.map((item, dateIndex) => {
                                            if (dateIndex <= skipTill) return null;

                                            const isHolidayDay = isHoliday(item.date);
                                            const isActive = dateIndex == activeIndex;
                                            const disabled = isDisabled(item.date);

                                            if (isHolidayDay) {
                                                let holidayGroup = [item];
                                                let nextIndex = dateIndex + 1;

                                                while (
                                                    dates[nextIndex] &&
                                                    isHoliday(dates[nextIndex].date)
                                                ) {
                                                    holidayGroup.push(dates[nextIndex]);
                                                    nextIndex++;
                                                }

                                                skipTill = nextIndex - 1;

                                                return (
                                                    <div key={dateIndex}>
                                                        <div className="calender-holidayDays">Holiday</div>

                                                        <div style={{ display: "flex" }}>
                                                            {holidayGroup.map((holidayItem, i) => (
                                                                <div key={i} className="calender-Holiday-cardBox">
                                                                    <span style={{ fontSize: 10 }}>
                                                                        {holidayItem.date.getDate()}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                );
                                            }

                                            return (
                                                <div
                                                    key={dateIndex}
                                                    onClick={() =>
                                                        !disabled && handleCalenderBoxPress(item.date, item.weekday)
                                                    }
                                                >
                                                    <div
                                                        style={{ backgroundColor: disabled ? "#cccc" : "" }}
                                                        className={`calender-cardBox test ${isActive ? "primary-bg" : "#ECECEC"}`}
                                                    >
                                                        <span style={{ color: disabled ? "#000" : isActive ? "#fff" : "#000", fontSize: 12 }}>
                                                            {item.weekday}
                                                        </span>
                                                        <span style={{ color: disabled ? "#000" : isActive ? "#fff" : "#000", fontSize: 10 }}>
                                                            {item.date.getDate()}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                );
                            })}
                    </div>

                )}


                {/* {
                    pageName == "memberShipDetails" ?
                        <div style={{ minWidth: '40%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                            <button style={{ border: "none", backgroundColor: 'white' }} onClick={() => { weekDisabled == false ? showToast() : updateMonthYear(-1) }}>
                                <IoIosArrowDropleftCircle size={25} className={`ms-1 ${weekDisabled == false ? "opacity_5 primary-text" : "primary-text"}  `} />
                            </button>
                            <div className='ms-3 mt-2 fs-14 ff-poppins-medium primary-text text-center'>
                                {selectedDate ? moment(selectedDate).format("D MMMM YYYY") : moment().format("D MMMM YYYY")}
                            </div>
                            <button style={{ border: "none", backgroundColor: 'white' }} onClick={() => { updateMonthYear(1); }}>
                                <IoIosArrowDroprightCircle size={25} className="ms-1 primary-text" />
                            </button>
                        </div> :
                        ""
                } */}


            </div>
        </div>
    );
};

export default TicketCalender;
